let componentsMenu = {
  path: '/components',
  component: () =>
    import(/* webpackChunkName: "routes" */ '@/pages/Dashboard/Dashboard.vue'),
  redirect: '/components/buttons',
  name: 'Components',
  children: [
    {
      path: 'notifications',
      name: 'Notifications',
      component: () =>
        import(
          /* webpackChunkName: "routes" */ '@/pages/Dashboard/Components/Notifications.vue'
        )
    }
  ]
}
let pagesMenu = {
  path: '/pages',
  component: () =>
    import(
      /* webpackChunkName: "routes" */ '@/pages/Dashboard/Layout/DashboardLayout.vue'
    ),
  name: 'Pages',
  redirect: '/pages/user',
  children: [
    {
      path: '/users',
      name: 'User Page',
      component: () =>
        import(
          /* webpackChunkName: "routes" */ '@/pages/Dashboard/Pages/Users.vue'
        )
    }
  ]
}

let authPages = {
  path: '/auth',
  component: () =>
    import(
      /* webpackChunkName: "routes" */ '@/pages/Dashboard/Pages/AuthLayout.vue'
    ),
  name: 'Authentication',
  meta: {
    requiresVisitor: true
  },
  children: [
    {
      path: '/login',
      name: 'Login',
      component: () =>
        import(
          /* webpackChunkName: "routes" */ '@/pages/Dashboard/Pages/Login.vue'
        )
    },

    {
      path: '/recovery_password',
      name: 'RecoveryPassword',
      component: () =>
        import(
          /* webpackChunkName: "routes" */ '@/pages/Dashboard/Pages/RecoveryPassword.vue'
        )
    },
    {
      path: '/reset_password/:token',
      name: 'ResetPassword',
      component: () =>
        import(
          /* webpackChunkName: "routes" */ '@/pages/Dashboard/Pages/ResetPassword.vue'
        )
    },
    {
      path: '/confirm_email/:token',
      name: 'ConfirmEmail',
      component: () =>
        import(
          /* webpackChunkName: "routes" */ '@/pages/Dashboard/Pages/ConfirmEmail.vue'
        )
    },
    {
      path: '/confirm_email_temp/:token',
      name: 'ConfirmEmail',
      component: () =>
        import(
          /* webpackChunkName: "routes" */ '@/pages/Dashboard/Pages/ConfirmEmailTemp.vue'
        )
    }
  ]
}

const routes = [
  componentsMenu,
  pagesMenu,
  authPages,
  {
    path: '/',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "routes" */ '@/pages/Dashboard/Layout/DashboardLayout.vue'
      ),
    children: [
      {
        path: '',
        redirect: 'calendarmultiple'
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/pages/Dashboard/Dashboard.vue'
          )
      },
      {
        path: '/calendar',
        name: 'calendar',
        meta: {
          requiresAuth: true,
          navbarFixed: true
        },
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/pages/Dashboard/Calendar.vue'
          )
      },
      {
        path: '/calendarmultiple',
        name: 'calendarmultiple',
        meta: {
          requiresAuth: true,
          navbarFixed: true
        },
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/pages/Dashboard/CalendarMultiple.vue'
          )
      },
      {
        path: '/workersSchedule',
        name: 'workersSchedule',
        meta: {
          requiresAuth: true,
          navbarFixed: true
        },
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/pages/Dashboard/WorkerSchedule.vue'
          )
      },
      {
        path: 'schedules',
        name: 'Schedules',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/pages/Dashboard/Pages/Schedules.vue'
          )
      },
      {
        path: 'events/new',
        name: 'NewEvents',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/pages/Dashboard/Events/EventsNew.vue'
          )
      },
      {
        path: 'events/:id/edit',
        name: 'EditEvent',
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/pages/Dashboard/Events/EventsNew.vue'
          )
      },
      {
        path: '/groups',
        name: 'Groups',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/pages/Dashboard/Pages/Groups.vue'
          )
      },
      {
        path: '/permissions',
        name: 'Permissions',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "routes" */ '@/pages/Dashboard/Pages/Permissions.vue'
          )
      },
      {
        path: '/rates',
        name: 'Rates',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "group-foo" */ '@/pages/Dashboard/Pages/RatesPage.vue'
          )
      },
      {
        path: '/audit',
        name: 'Audit',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "group-foo" */ '@/pages/Dashboard/Pages/Audit.vue'
          )
      },
      {
        path: '/user',
        name: 'Users',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "group-foo" */ '@/pages/Dashboard/Pages/Users.vue'
          )
      },
      {
        path: '/profile',
        name: 'User Profile',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "group-foo" */ '@/pages/Dashboard/Pages/Profile.vue'
          )
      },
      {
        path: '/roles',
        name: 'Roles',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "group-foo" */ '@/pages/Dashboard/Pages/Roles.vue'
          )
      },
      {
        path: '/configurations',
        name: 'Configurations',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "group-foo" */ '@/pages/Dashboard/Pages/NotificationsSettings.vue'
          )
      }
    ]
  },

  {
    path: '*',
    meta: { Layout: 'blank' },
    component: () => import('../components/error/404.vue')
  },
  {
    path: '/confirm/email',
    meta: { Layout: 'blank' },
    name: 'ConfirmEmailPassword',
    component: () =>
      import(
        /* webpackChunkName: "group-foo" */ '@/pages/Dashboard/Pages/ConfirmEmailPassword.vue'
      )
  }
]

export default routes
